import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Offcanvas,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../Blog/BlogSection.css";
import { useLoader } from "../loader/LoaderContext";
import { format2 } from "../../utils/money";

const removeHTMLTags = (text = "") => text.replace(/<[^>]*>/g, "");
const truncate = (str = "", maxLength = 150) =>
  str.length > maxLength ? str.slice(0, maxLength) + "..." : str;

const BlogSection = () => {
  const { showLoader, hideLoader } = useLoader();
  const [blogPosts, setBlogPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;

  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      showLoader();
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    } finally {
      hideLoader();
    }
  };

  const handleEmailClick = () => {
    const email = "contact@toptennis.io";
    const subject = "";
    const body = "";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const fetchMarketStatus = async () => {
    showLoader(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/public/market-status",
        {
          // headers: { Authorization: `Bearer ${Token}` },
        }
      );

      // Extract values from the API response
      const { isFrozen, bannerText } = response.data;

      // Update state with both values
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || ""); // Ensure it's not undefined
      await fetchUserValues();
      hideLoader();
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      hideLoader(); // Ensure loader stops after API response
    }
  };

  useEffect(() => {
    fetchMarketStatus();
    fetchUserValues();
  }, []);

  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const fetchPlayersAndMergeData = async () => {
      const Token = localStorage.getItem("user_token");
      try {
        showLoader();
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;
        const response = await axios.get(
          `https://toptennis.io/api/users/selected-teamlist/${userId}`,
          { headers: { Authorization: `Bearer ${Token}` } }
        );
        if (response.data && response.data.status) {
          const { team, valueDifferences } = response.data;
          const valueDifferenceMap = valueDifferences.reduce(
            (acc, valueDifference) => {
              acc[valueDifference.player_id] = valueDifference;
              return acc;
            },
            {}
          );
          const mergedData = team.players.map((player) => {
            const differenceData = valueDifferenceMap[player._id] || {};
            return {
              ...player,
              currentValue: differenceData.value || player.value,
              valueDifference: differenceData.valueDifference || 0,
            };
          });
          setPlayers(mergedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        hideLoader();
      }
    };
    fetchPlayersAndMergeData();
  }, []);

  const [show1, setShow1] = useState(false);
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [withdrawableCredits, setWithdrawableCredits] = useState(0);
  const [userName, setUserName] = useState("");
  const [totalSpent, setTotalSpent] = useState(0);
  const [tags, setTags] = useState([]);
  const isLoggedIn = !!localStorage.getItem("user_token");
  const [selectedTag, setSelectedTag] = useState("");
  const [totalDeposit, setTotalDeposit] = useState(0);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    if (term === "") {
      setFilteredPosts(blogPosts);
    } else {
      const filtered = blogPosts.filter(
        (post) =>
          post.title.toLowerCase().includes(term) ||
          removeHTMLTags(post.description).toLowerCase().includes(term) ||
          post.category?.toLowerCase().includes(term)
      );
      setFilteredPosts(filtered);
    }
  };

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");
    if (Token) {
      try {
        showLoader();
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );
        const {
          name,
          credits,
          withdrawableCredits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
          totalDeposit,
        } = response.data;
        setUserName(name);
        setCredits(credits);
        setWithdrawableCredits(withdrawableCredits);
        setInPlayValue(grand_total_value);
        setTotalSpent(player_value_sum);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
        setTotalDeposit(totalDeposit || 0);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      } finally {
        hideLoader();
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      const token = localStorage.getItem("user_token");
      try {
        showLoader();
        const res = await axios.get(
          "https://toptennis.io/api/public/getAllBlog",
          {
            // headers: { authorization: `Bearer ${token}` },
          }
        );
        const blogs = res.data.blogs || [];
        setBlogPosts(blogs);
        setFilteredPosts(blogs);

        // const allTags = res.data.blogs
        //   .flatMap((blog) => blog.tag || [])
        //   .filter((tag, index, self) => self.indexOf(tag) === index);
        // setTags(allTags);

        // Tag Frequency Count
        const tagCountMap = {};
        blogs.forEach((blog) => {
          if (blog.tag) {
            const tags = blog.tag.split(",").map((t) => t.trim().toLowerCase());
            tags.forEach((tag) => {
              tagCountMap[tag] = (tagCountMap[tag] || 0) + 1;
            });
          }
        });

        // Sort tags by frequency and remove duplicates
        const sortedTags = Object.entries(tagCountMap)
          .sort((a, b) => b[1] - a[1])
          .map(([tag]) => tag);

        setTags(sortedTags);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      } finally {
        hideLoader();
      }
    };
    fetchBlogs();
  }, []);

  // Pagination logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container>
      <Row className="w-100 justify-content-center rowdiv">
        {isLoggedIn ? (
          <>
            <div className="freeze-banner">
              <p>{freezeMessage}</p>
            </div>
            <div className="user-info">
              <button
                variant="light"
                className="d-md-none menu-btn"
                onClick={handleShow1}
              >
                ☰
              </button>
              <div className="left-section1 d-flex1">
                <span className="welcome-text">Welcome, {userName}</span>
                <div className="top-navigation d-none d-md-flex">
                  <span className="nav-item" onClick={() => navigate("/home")}>
                    Home
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/myteam")}
                  >
                    My Team
                  </span>
                  <span className="nav-item" onClick={() => navigate("/faq")}>
                    FAQs
                  </span>
                  <span
                    className="nav-item active"
                    onClick={() => navigate("/news")}
                  >
                    News
                  </span>
                  <span className="nav-item" onClick={handleLogout}>
                    Logout
                  </span>
                </div>
              </div>
              <Offcanvas show={show1} onHide={handleClose1} placement="start">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="mobile-nav">
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/home");
                        handleClose1();
                      }}
                    >
                      Home
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/profile");
                        handleClose1();
                      }}
                    >
                      Profile
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/myteam");
                        handleClose1();
                      }}
                    >
                      My Team
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/news");
                        handleClose1();
                      }}
                    >
                      News
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/faq");
                        handleClose1();
                      }}
                    >
                      FAQs
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        handleLogout();
                        handleClose1();
                      }}
                    >
                      Logout
                    </span>
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
              <div className="right-section1">
                <div className="credit-box-container">
                  <button
                    className="topup-button"
                    onClick={() => {
                      navigate("/topup");
                    }}
                  >
                    Top-up
                  </button>
                  <div className="credit-box">
                    <p className="p">
                      Credit available: <span>{format2(credits + withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      Withdrawable Credit: <span>{format2(withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      In-play: <span>{inPlayValue.toFixed(2)}</span>
                    </p>
                    <p className="p">
                      Current Team P/L:&nbsp;
                      <span
                        style={{
                          color:
                            Number(differenceValue) > 0
                              ? "green"
                              : Number(differenceValue) < 0
                              ? "red"
                              : "black",
                        }}
                      >
                        {differenceValue
                          ? Number(differenceValue) > 0
                            ? `+${Number(differenceValue).toFixed(2)}`
                            : Number(differenceValue).toFixed(2)
                          : "0.00"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="freeze-banner">
            <p>{freezeMessage}</p>
          </div>
        )}
      </Row>

      <Row className="blog-container">
        {/* Left Column - Blog Posts */}
        <Col lg={9} className="blog-posts-column">
          <Row className="blog-posts-grid">
            {currentPosts.map((post) => (
              <Col md={6} key={post._id} className="mb-4 eachh">
                <div
                // <div
                  className="blog-card h-100 "
                  onClick={() => navigate(`/blog/${post._id}`)}
                  style={{ cursor: "pointer",backgroundColor:"white" }}
                >
                  <div className="blog-card-inner">
                    {post.thumbnailImg && (
                      <div className="blog-image-container">
                        <img
                          src={`https://toptennis.io/api/${post.thumbnailImg}`}
                          className="blog-image"
                          alt={post.title}
                        />
                      </div>
                    )}
                    <Card.Body className="blog-content">
                      <div className="post-date">
                        {new Date(post.createdAt)
                          .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })
                          .replace(/\//g, ".")}
                      </div>
                      <Card.Title className="post-title">
                        {removeHTMLTags(post.title)}
                      </Card.Title>
                      <Card.Text className="post-excerpt">
                        {truncate(removeHTMLTags(post.description), 100)}
                      </Card.Text>
                      <div className="author-info">
                        {post.authorImg && (
                          <img
                            src={`https://toptennis.io/api/${post.authorImg}`}
                            className="author-image"
                            alt={post.author}
                          />
                        )}
                        <div className="author-details">
                          <div className="author-name">{post.author}</div>
                          <div className="author-designation">
                            {post.designation}
                          </div>
                        </div>
                      </div>
                      {/* <Button variant="link" className="read-more-btn">...more</Button> */}
                    </Card.Body>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i}
                      className={`page-item ${
                        currentPage === i + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          )}
        </Col>

        {/* Right Column - Search */}
        <Col lg={3} className="search-sidebar">
          <div className="search-box sticky-top">
            <Form.Control
              type="text"
              placeholder="Q. Search here"
              value={searchTerm}
              onChange={handleSearch}
              className="search-input1 mb-4"
            />
          </div>
          <div className="blog-tags mt-3">
            <h6 className="fw-bold">Tags</h6>
            <div className="tag-list">
              {tags.map((tag, index) => (
                <div
                  key={index}
                  className="tag-item"
                  onClick={async () => {
                    if (selectedTag === tag) {
                      // If clicking the same tag, reset to all blogs
                      setFilteredPosts(blogPosts);
                      setSearchTerm("");
                      setSelectedTag("");
                      setCurrentPage(1);
                    } else {
                      // Fetch blogs with tag as search
                      try {
                        showLoader();
                        const res = await axios.get(
                          `https://toptennis.io/api/public/getAllBlog?search=${encodeURIComponent(
                            tag
                          )}`
                        );
                        const blogs = res.data.blogs || [];
                        setFilteredPosts(blogs);
                        setSearchTerm(tag);
                        setSelectedTag(tag);
                        setCurrentPage(1);
                      } catch (err) {
                        console.error("Error fetching blogs by tag:", err);
                      } finally {
                        hideLoader();
                      }
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    marginBottom: "6px",
                    color: selectedTag === tag ? "#fff" : "#000",
                    background: selectedTag === tag ? "#10bb10" : "#eee",
                    borderRadius: "12px",
                    padding: "4px 12px",
                    display: "inline-block",
                    marginRight: "6px",
                    fontWeight: selectedTag === tag ? 700 : 400,
                  }}
                >
                  {tag}
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
      <div className="card-footer-topup">
        <div className="footer">
          <div className="footer-firstline">
            <div className="footer-sub">
              <h4>Keep in touch</h4>
              <h5>Join our newsletter. We promise not to spam!</h5>
              <input
                type="email"
                placeholder="Email Address"
                className="footer-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="subscribe-btn" onClick={handleSubscribe}>
                Subscribe
              </button>
              {message && (
                <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                  {message}
                </p>
              )}
            </div>

            <div className="footer-sub1">
              <h4>Quick links</h4>
              {localStorage.getItem("user_token") ? (
                <>
                  <a href="/home" className="footer-link">
                    Home
                  </a>
                  <a href="/profile" className="footer-link">
                    Profile
                  </a>
                  <a href="/myteam" className="footer-link">
                    My Team
                  </a>
                </>
              ) : null}
              <a href="/news" className="footer-link">
                News
              </a>
              <a href="/faq" className="footer-link">
                FAQs
              </a>
            </div>

            <div className="footer-sub1 secondicon">
              <h4>Socials</h4>
              {/* <div className="social-icons">
                <div className="social-circle">
                  <i className="fab fa-facebook-f"></i>
                </div>
                <div className="social-circle">
                  <i className="fab fa-instagram"></i>
                </div>
              </div> */}
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/toptennisio/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href="https://www.instagram.com/toptennisuk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>

              <div className="fl1">
                <a
                  href="/terms"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  T&Cs
                </a>
                <a
                  href="/privacy"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                <span className="footer-link">Email: contact@toptennis.io</span>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BlogSection;
